import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { BiHome, BiBusSchool, BiPackage, BiDesktop } from 'react-icons/bi';

const ActiviteTypesDetails: React.FC = () => {
    return (
        <>
            <Row>
                <Col className="text-center">
                    <BiHome size="4em" />
                    <h5>Entrée</h5>
                    <p className="mb-1">Activité qui se déplace</p>
                    <small className="text-muted">(Exemple : un magicien à l&apos;école.)</small>
                </Col>
                <Col className="text-center">
                    <BiBusSchool size="4em" />
                    <h5>Sortie</h5>
                    <p className="mb-1">Activité qui vous reçoit dans ses locaux</p>
                    <small className="text-muted">(Exemple : aller au Centre des Sciences de Montréal.)</small>
                </Col>
                <Col className="text-center">
                    <BiPackage size="4em" />
                    <h5>Livraison</h5>
                    <p className="mb-1">Produit qui est livré à l&apos;école</p>
                    <small className="text-muted">(Exemple : livraison de toutous à l&apos;école.)</small>
                </Col>
                <Col className="text-center">
                    <BiDesktop size="4em" />
                    <h5>En Ligne</h5>
                    <p className="mb-1">Activité qui requiert une connexion à Internet et un ordinateur</p>
                    <small className="text-muted">
                        (Exemple : Instructions vidéo pour faire une expérience scientifique)
                    </small>
                </Col>
            </Row>
        </>
    );
};

export default ActiviteTypesDetails;
